import { Component, Input } from '@angular/core';
import { CardComponent } from "@shared/components/card/card.component";
import { CircleCheck, CircleMinus, LucideAngularModule } from "lucide-angular";
import { ReactiveFormsModule } from "@angular/forms";
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-guide-card',
  imports: [
    CardComponent,
    LucideAngularModule,
    ReactiveFormsModule,
    NgClass
  ],
  templateUrl: './guide-card.component.html',
  styleUrl: './guide-card.component.css'
})
export class GuideCardComponent {
  @Input() public valid?: boolean = false;
  @Input() public hidden: boolean = false;
  @Input() public fullWidth: boolean = false;

  /** Icons **/
  protected readonly CircleMinus = CircleMinus;
  protected readonly CircleCheck = CircleCheck;

}
